import { stegaClean } from '@/lib/utils/stega';
import { ICONS, type IconName } from './UiIcon.constants';
import type { UiIconProps } from './UiIcon.types';

export function UiIcon({ name, size = '1em', className, ...props }: UiIconProps) {
    // `name` may be a Sanity-stored value; strip stega so the key lookup works in draft mode too.
    const Icon = ICONS[stegaClean(name) as IconName];
    if (!Icon) return null;

    // Sizing via width/height attributes, never via a utility class: attributes lose against
    // every CSS rule, so a `className` from any layer (utility or component class) still wins.
    return <Icon width={size} height={size} className={className} {...props} />;
}
